












/* Created- 25 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import ForgotPasswordForm from "@/Ui-Components/Account/ForgotPasswordForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { AccountClient } from "../Generated/ParticaAPI";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../Models/Buttons";

@Component(
	{
		name: "ForgottenPassword",
		components: { ForgottenPassword, ForgotPasswordForm, ParticaError, ParticaRowContainer, ParticaCard }
	})
export default class ForgottenPassword extends ParticaBaseView {
	private accountService: AccountClient;
	private forgotemail: string = "";
	private forgotbuttons: ButtonConfig[] = [
		{ label: "Send Password Reset Email", action: eParticaAction.ACCOUNT_RESET_PASSWORD, type: ButtonType.OK } as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ACCOUNT_RESET_PASSWORD: {
					await this.accountService.sendResetPassword(event.item, location.protocol + "//" + location.host);
					this.ShowSnackbar("Check your email to reset your password.");
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);			}
	}

	private async mounted() {
		this.accountService = new AccountClient();
	}
}
